import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { PartSelection } from '@/components/families/ori/Ori9';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';
import * as _ from 'lodash';
import $ from 'jquery';

@Component({

})
export default class AccList extends Vue {
  @Prop() plattes: any;
  @Prop() product: any;
  @Prop() selectedPart: any;
  selectedColor: any = null;
  selectedPallate: any = null;
  selection: any = null;



  platteType(plate) {
    let result = '';
    const type = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === plate).type;
    if (type) {
      result = type;
    }
    return result;
  }
  created() {
    this.refresh();
  }

  toggle(num: any) {
    if (this.$el.children[num].classList.contains('open')) {

      this.$el.children[num].classList.remove('open');
      const con = this.$el.children[num].querySelectorAll('.faq-content')[0] as any;
      con.style.display = 'none';
    } else {

      const prevFaqQuestion = this.$el.querySelectorAll('.open');
      if (prevFaqQuestion.length !== 0) {
        prevFaqQuestion[0].classList.remove('open');
        const con2 = prevFaqQuestion[0].querySelectorAll('.faq-content')[0] as any;
        con2.style.display = 'none';
      }
      this.$el.children[num].classList.add('open');
      const con3 = this.$el.children[num].querySelectorAll('.faq-content')[0] as any;
      con3.style.display = '';
    }
  }
  selectedPaletteColors(pal: any) {
    if (pal) {
      const palettes = Store.state.configuratorConfig.definitions.palettes;
      return palettes.find(x => x.id === pal).colors;
    }

    return [];
  }

  colorClick(color: any, palette: any) {
    this.selectedColor = color.name;
    this.selectedPallate = palette;
    this.$emit('colorChangedByAccList', color.name, palette);
  }

  @Watch('selectedPart')
  watchSelectedPart(newPart, oldPart) {

    this.selectedPart = newPart;
    this.refresh();
  }

  public refresh() {

    if (Store.state.selection) {
      const part: Readonly<PartSelection> = Store.state.selection.parts.find(x => x.id === this.selectedPart);
      this.selectedPallate = part.palette;
      this.selectedColor = part.color;
    } else {
      const part: Readonly<PartSelection> = this.product.defaults.parts.find(x => x.id === this.selectedPart);
      this.selectedPallate = part.palette;
      this.selectedColor = part.color;
    }
  }

  hasNumbers(t: string) {
    const regex = /\d/g;
    return regex.test(t);
  }

  colorCode(color: string) {
    let result =  color;
    const strs = color.split('_');
    strs.forEach((element) => {
      if (this.hasNumbers(element)) {
        result = element;
        return;
      }
    });
    return result;
  }

  isReady: boolean = false;
  mounted() {
    this.$nextTick(() => {
      this.isReady = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/acc-list/AccList.ts